/**
 * A list of constants by which the dashboard overview view can be sorted.
 * The keys are based on a single element of the format for Dashboards
 * (As expected by 'dashboards' state in the dashboards-overview store).
 */
export const DASHBOARD_SORT_ENUM = Object.freeze({
  lastModifiedAt: 'Last modified',
  titleAscending: 'Title, A - Z',
  titleDescending: 'Title, Z - A',
});

/**
 * A config of sort iteratee and order based on the available UI options for
 * DASHBOARD_SORT_ENUM that can be used to sort a field in ascending/descending order.
 */
export const DASHBOARD_SORT_CONFIG_ENUM = Object.freeze({
  lastModifiedAt: { iteratee: 'lastModifiedAt', order: 'desc' },
  titleAscending: {
    iteratee: entity => entity.title.toLowerCase(),
    order: 'asc',
  },
  titleDescending: {
    iteratee: entity => entity.title.toLowerCase(),
    order: 'desc',
  },
});

export const DASHBOARD_SORT_ENUM_DEFAULT = 'lastModifiedAt';

export const DASHBOARD_SORT_OPTIONS = Object.keys(DASHBOARD_SORT_ENUM).map(
  key => ({ value: key, label: DASHBOARD_SORT_ENUM[key] })
);

// define a max and min size (privately)
const GRID_MAX_SIZE = 10;
const GRID_MIN_SIZE = 1;
const GRID_DEFAULT_SIZE = 2;

export const GRID_LAYOUT = Object.freeze({
  COLUMNS: 100,
  ROW_HEIGHT: 200,
  DEFAULT_WIDTH: GRID_DEFAULT_SIZE,
  DEFAULT_HEIGHT: GRID_DEFAULT_SIZE,
  MAX_PLACEMENT_COLUMN: 8,
  MIN_SIZE: GRID_MIN_SIZE,
  MAX_SIZE: GRID_MAX_SIZE,
  GRID_WIDTH: 19000,
});

export const DASHBOARD_SCHEMA_PROTECTED_FIELDS = [
  'everyone',
  'owners',
  'authors',
  'viewers',
  'schemaVersion',
];

export const DASHBOARD_PERMISSION_ROLES = {
  VIEWER: 'viewer',
  AUTHOR: 'author',
  OWNER: 'owner',
};

export const DASHBOARD_SHOW_PERMISSIONS_DEFAULT = 'everyone';

// properties that ought to be excluded from metadata.dashboards as they are only required in the UI
export const DASHBOARD_UI_PROPERTIES = [
  '_id',
  'permissionsSummary',
  'permissionedUsers',
  'isGrantingDataSourcePermissions',
  'everyoneMissingDataSourcePermissions',
  'uniqueDataSourceIds',
];

export const DASHBOARD_SHOW_PERMISSIONS = {
  [DASHBOARD_SHOW_PERMISSIONS_DEFAULT]: 'All Dashboards',
  [DASHBOARD_PERMISSION_ROLES.VIEWER]: "I'm a Viewer",
  [DASHBOARD_PERMISSION_ROLES.AUTHOR]: "I'm an Author",
  [DASHBOARD_PERMISSION_ROLES.OWNER]: "I'm an Owner",
};

export const DASHBOARD_SHOW_PERMISSION_OPTIONS = Object.keys(
  DASHBOARD_SHOW_PERMISSIONS
).map(key => ({
  value: key,
  label: DASHBOARD_SHOW_PERMISSIONS[key],
}));
